<template lang="pug">
include ./../../../s-pug/mixin-footer

.Window#top
   vue-snotify()
   //- Header Home
   //- ._mb1._px1._py075(v-if="this.$route.name === 'home'")
      .Logo._flex._flex-alignItemsCenter
         //- ._flex._flexDirection-column._mr05(style="width: 50px")
            include /pug/logo.svg
         //- h1._fs-4._bold {{$static.metadata.siteName}}
         h1._fs-4._bold Good Remote
      ._absolute._t0._r0._p1(v-show="isLoaded")
         div(v-show="!isAuthenticated")
            router-link.Btn.Btn--yellow._px1._py05(to="/start/") 
               span._fs-3._mr05 + 
               | Add your team
            ._mt075._t-right._c-grey-600._fs-075
               | Already added? 
               router-link._link-subtle(to="/sign-in/") Sign in
         router-link.Btn.Btn--white._px1._py05(to="/user/settings/" v-show="isAuthenticated") Account
   //- Header NOT Home
   //- ._px1._py05._borderBottom-default._borderColor-grey-100._bg-white._flex._flex-justifySpaceBetween(v-else v-show="isLoaded")
   ._px1._py05._borderBottom-default._borderColor-grey-100._bg-white._flex._flex-justifySpaceBetween
      router-link._link-subtle._inlineBlock._textDecoration-none._flex-alignSelfCenter._flex._flex-alignItemsCenter(to="/")
         //- h1._fs-4._bold {{$static.metadata.siteName}}
         h1._fs-4 
            span._fs-4._bold Good Remote
            span._fs-2._c-grey-500._ml1 Account
      //- div(v-show="!isAuthenticated")
         router-link.Btn.Btn--yellow._px1._py05._flex-alignSelfCenter(to="/start/")
            span._fs-3._mr05 + 
            | Add your team
      //- div(v-show="isAuthenticated")
         router-link.Btn.Btn--white._px1._py05._flex-alignSelfCenter(to="/user/settings") Account
   .Main(:class="[{'Layout': includeLayoutClass}, layoutClassesFromChild]")
      slot
   +footer('account')
</template>

<script>
import { mapState } from 'vuex'
import router from './../router'

export default {
   props: ['includeLayoutClass', 'layoutClassesFromChild'],
   computed: {
      ...mapState(['isAuthenticated']),
   },
}
</script>

<style lang="sass" scoped>
.Main
   // for sticky footer
   flex: 1
.Layout
   max-width: 960px
   width: 100%
   +mx(auto)
   +px($s-1)
   padding-top: $s-1
   &.Layout--content
      max-width: 700px
.Logo
   color: black
// html
   // background-color: $yellow-vivid-100
   // border-top: solid 3px $yellow-vivid-400
   // border-bottom: solid 3px $yellow-vivid-400
</style>
